// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patchyLineExample {
  width: 100%;
}

.inputs {
  font-family: 'Courier New', Courier, monospace;
  font-size: smaller;
  margin-bottom: 12px;
}

.inputs > label {
  display: flex;
  align-items: center;
}

.singleLines {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 10px;
}

`, "",{"version":3,"sources":["webpack://./src/examples/xy-components/line/patchy-line/style.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qCAAqC;EACrC,gBAAgB;AAClB","sourcesContent":[".patchyLineExample {\n  width: 100%;\n}\n\n.inputs {\n  font-family: 'Courier New', Courier, monospace;\n  font-size: smaller;\n  margin-bottom: 12px;\n}\n\n.inputs > label {\n  display: flex;\n  align-items: center;\n}\n\n.singleLines {\n  display: grid;\n  width: 100%;\n  grid-template-columns: repeat(3, 1fr);\n  column-gap: 10px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"patchyLineExample": `patchyLineExample`,
	"inputs": `inputs`,
	"singleLines": `singleLines`
};
export default ___CSS_LOADER_EXPORT___;
